import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

import MaintenanceDashboardBlock from './MaintenanceDashboardBlock';
import ReportSensorsTable from './ReportSensorsTable';

const ReportOverviewBlock = ({
  onDownload,
  downloading,
  reportSensors,
  error,
  onSensorClick,
  selectedSensorId,
  sortConfig,
  onSortChange,
  timeZone,
  projectTimeZone,
  t,
}) => (
  <MaintenanceDashboardBlock
    title={t('maintenance_report') || 'Maintenance Report'}
    icon={<AssessmentOutlinedIcon />}
    className='report-overview-block'
    headerAction={
      <Button
        size='small'
        variant='contained'
        startIcon={<DownloadOutlinedIcon />}
        onClick={onDownload}
        disabled={downloading}
        className='report-download-button'
      >
        {downloading
          ? t('downloading') || 'Downloading...'
          : t('download') || 'Download'}
      </Button>
    }
  >
    <Box className='report-overview-content'>
      {error && (
        <Typography className='report-overview-error'>{error}</Typography>
      )}

      <ReportSensorsTable
        reportSensors={reportSensors}
        onSensorClick={onSensorClick}
        emptyText={
          t('no_sensors_found_for_maintenance_report')
          || 'No sensors found for the Maintenance report.'
        }
        selectedSensorId={selectedSensorId}
        sortConfig={sortConfig}
        onSortChange={onSortChange}
        timeZone={timeZone}
        projectTimeZone={projectTimeZone}
        slowVerticalScroll
        t={t}
      />
    </Box>
  </MaintenanceDashboardBlock>
);

ReportOverviewBlock.propTypes = {
  onDownload: PropTypes.func.isRequired,
  downloading: PropTypes.bool,
  reportSensors: PropTypes.arrayOf(PropTypes.object),
  error: PropTypes.string,
  onSensorClick: PropTypes.func.isRequired,
  selectedSensorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sortConfig: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
  }).isRequired,
  onSortChange: PropTypes.func.isRequired,
  timeZone: PropTypes.string,
  projectTimeZone: PropTypes.string,
  t: PropTypes.func.isRequired,
};

ReportOverviewBlock.defaultProps = {
  reportSensors: [],
  downloading: false,
  error: null,
  selectedSensorId: '',
  timeZone: 'gmt',
  projectTimeZone: '',
};

export default ReportOverviewBlock;
